import { render, staticRenderFns } from "./bearish_key_reversal.vue?vue&type=template&id=d520d126"
import script from "./bearish_key_reversal.vue?vue&type=script&lang=js"
export * from "./bearish_key_reversal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports